import { render, staticRenderFns } from "./CopyTextControl.vue?vue&type=template&id=3de35469"
import script from "./CopyTextControl.vue?vue&type=script&lang=js"
export * from "./CopyTextControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports